// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import useTerminalStore from '@/app/store/modules/terminal';
import actionsPosTerminals from '../../api/actionsPosTerminals';
// Components
import DataTable from '../../../../../common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import { columnsTerminalEventLogs, columnsTerminalEventLogsId } from './columnDef/columnsEventLogs';

/**
 * @param root0
 * @param root0.posTerminalId
 * @param root0.customQuery
 * @param root0.filtersEventName
 * @returns {JSX} TerminalEventLogsTable
 */
function TerminalEventLogsTable({ posTerminalId = undefined, customQuery = {}, filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchTerminalEventLogs: refetchFromStore, storeRefetchTerminalEventLogs, queryEventLogs: queryStored, storeQueryEventLogs } = useTerminalStore();

    // State
    const initialQuery = getInitialQuery(customQuery);
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsPosTerminals.getEventLogs({ query: query, posTerminalId: posTerminalId }, false);

    // Saves custom query in store
    useEffect(() => {
        if (customQuery.filters && customQuery.filters.length > 0) {
            storeQueryEventLogs(initialQuery);
        }
    }, [customQuery]);

    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchTerminalEventLogs(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsTerminalEventLogs({ query, setQuery, queryStored, storeQueryEventLogs, setLaunchRefetch, filtersEventName });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsTerminalEventLogsId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQueryEventLogs}
            setLaunchRefetch={setLaunchRefetch}
        />
    );
}

TerminalEventLogsTable.propTypes = {
    posTerminalId: PropTypes.string,
    filtersEventName: PropTypes.string
};

export default TerminalEventLogsTable;